import { render, staticRenderFns } from "./TourDetailsPrice.vue?vue&type=template&id=31ae24a8&scoped=true"
import script from "./TourDetailsPrice.vue?vue&type=script&lang=js"
export * from "./TourDetailsPrice.vue?vue&type=script&lang=js"
import style0 from "./TourDetailsPrice.vue?vue&type=style&index=0&id=31ae24a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae24a8",
  null
  
)

export default component.exports